import { qbHttp } from "./http";

export const listSeasons = (params = {}) =>
  qbHttp.request("api/qb/seasons", { query: params });

export const getSeason = (id) => qbHttp.request(`api/qb/seasons/${id}`);

export const createSeason = (body) =>
  qbHttp.request("api/qb/seasons", { method: "POST", body });

export const updateSeason = (id, body) =>
  qbHttp.request(`api/qb/seasons/${id}`, { method: "PUT", body });

export const deleteSeason = (id) =>
  qbHttp.request(`api/qb/seasons/${id}`, { method: "DELETE" });
